import { createUserPositionMarker } from './user-position.js';
import {appendCameraToUrl} from '../lib/camera-state.js';
import { openMapImage, initMapImageTranslations } from './map-image.js';
// Toolbar v2 — locate (con stima locale pesata dalle stazioni, come la v1),
// condividi (navigator.share → clipboard), fullscreen. Il tema è in panel.js.
import { state as stationsState } from '../layers/stations.js';
import { formatValue, chartUnitForParam } from '../lib/params.js';

function iconBtn(id, title, glyph) {
    const b = document.createElement('button');
    b.className = 'wsv2-iconbtn';
    b.id = id;
    b.title = title;
    b.setAttribute('aria-label', title);
    b.textContent = glyph;
    return b;
}

function haversineKm(aLat, aLon, bLat, bLon) {
    const R = 6371, rad = Math.PI / 180;
    const dLat = (bLat - aLat) * rad, dLon = (bLon - aLon) * rad;
    const s = Math.sin(dLat / 2) ** 2 + Math.cos(aLat * rad) * Math.cos(bLat * rad) * Math.sin(dLon / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(s));
}

// Stima locale: media pesata gaussiana delle stazioni vicine (spirito v1
// map-ui.js estimateLocalValue; da riallineare 1:1 in fase M5).
function estimateLocal(lat, lon, parametro) {
    let num = 0, den = 0, nearest = null, nearestKm = Infinity;
    for (const rec of stationsState.records) {
        const km = haversineKm(lat, lon, rec.lat, rec.lon);
        if (km < nearestKm) { nearestKm = km; nearest = rec; }
        if (km > 25) continue;
        const w = Math.exp(-(km / 8) * (km / 8));
        num += w * rec.raw;
        den += w;
    }
    if (!den || !nearest) return null;
    return { value: num / den, nearest, nearestKm };
}

export function initToolbar(map) {
    initMapImageTranslations();
    const positionMarker = createUserPositionMarker(map, maplibregl, document);
    const bar = document.querySelector('.wsv2-topbar');
    const anchor = document.getElementById('btnTheme');

    const btnLocate = iconBtn('btnLocate', 'La mia posizione', '⌖');
    const btnShare = iconBtn('btnShare', 'Condividi vista', '↗');
    const btnFs = iconBtn('btnFs', 'Schermo intero', '⛶');
    const btnImage = iconBtn('btnMapImage', 'Immagine della mappa', '');
    btnImage.innerHTML = '<svg width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 7h4l2-3h4l2 3h4v13H4z"/><circle cx="12" cy="13" r="4"/></svg>';
    btnLocate.classList.add("ws-user-locate");
    document.body.appendChild(btnLocate);
    bar.insertBefore(btnShare, anchor);
    bar.insertBefore(btnImage, bar.querySelector('.wsv2-spacer'));
    bar.insertBefore(btnFs, anchor);
    btnImage.addEventListener('click', () => openMapImage(map, btnImage));

    btnLocate.addEventListener('click', () => {
        if (!navigator.geolocation) return;
        btnLocate.textContent = '…';
        navigator.geolocation.getCurrentPosition((pos) => {
            btnLocate.textContent = '⌖';
            const { latitude: lat, longitude: lon } = pos.coords;
            positionMarker.update(pos.coords, pos.timestamp);
            map.flyTo({ center: [lon, lat], zoom: Math.max(map.getZoom(), 11.5), speed: 1.6 });
            const parametro = document.getElementById('selectParametro')?.value || 'temperatura';
            const est = estimateLocal(lat, lon, parametro);
            const unit = chartUnitForParam(parametro);
            const html = est
                ? `<div class="ws-station-tooltip"><div class="ws-station-tooltip__name">Qui adesso ≈ ${formatValue(parametro, est.value)}${unit ? ' ' + unit : ''}</div>
                   <div class="ws-station-tooltip__altitude">stima dalle stazioni vicine · la più vicina: ${String(est.nearest.station.name || '').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]))} (${est.nearestKm.toFixed(1)} km)</div></div>`
                : `<div class="ws-station-tooltip"><div class="ws-station-tooltip__name">Sei qui</div></div>`;
            new maplibregl.Popup({ closeButton: true, className: 'wsv2-tooltip-shell', offset: 8 })
                .setLngLat([lon, lat]).setHTML(html).addTo(map);
        }, () => { btnLocate.textContent = '⌖'; }, { enableHighAccuracy: true, timeout: 12000 });
    });

    btnShare.addEventListener('click', async () => {
        const c = map.getCenter();
        const url = new URL(window.location.href);
        url.searchParams.set('lat', c.lat.toFixed(5));
        url.searchParams.set('lon', c.lng.toFixed(5));
        url.searchParams.set('zoom', map.getZoom().toFixed(2));
        const parametro = document.getElementById('selectParametro')?.value;
        if (parametro) url.searchParams.set('type', parametro);
        appendCameraToUrl(url,map);
        const link = url.toString();
        try {
            if (navigator.share) await navigator.share({ title: 'Weather Sicily Maps', url: link });
            else { await navigator.clipboard.writeText(link); btnShare.textContent = '✓'; setTimeout(() => { btnShare.textContent = '↗'; }, 1200); }
        } catch (e) { /* annullato */ }
    });

    btnFs.addEventListener('click', () => {
        if (document.fullscreenElement) document.exitFullscreen?.();
        else document.documentElement.requestFullscreen?.();
    });
}
